import data from "@/config/template/TableGuide/data.json"
import { CurrentAppResp } from "@/page/App/resp/currentAppResp"

export const TABLE_GUIDE_DATA = data as unknown as CurrentAppResp
